import { render } from "./ticket.vue?vue&type=template&id=4e598607&scoped=true"
import script from "./ticket.vue?vue&type=script&lang=js"
export * from "./ticket.vue?vue&type=script&lang=js"

import "./ticket.vue?vue&type=style&index=0&id=4e598607&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e598607"]])

export default __exports__